module.exports = __webpack_public_path__ + "static/media/background-gradient.67e69c88.svg";